module.exports = __webpack_public_path__ + "static/media/cover7.33f82eed.png";